import { Card, CardHeader } from "@material-ui/core";
import React, { FC } from "react";
import { OrderDeliveryMethod } from "interfaces/front/business";

export const OrderDeliveryMethodArea: FC<{ delivery_method: OrderDeliveryMethod }> = ({ delivery_method }) => {
  return (
    <Card variant={"outlined"} style={{ margin: "10px 0" }}>
      <CardHeader disableTypography title={delivery_method.method} style={{ fontSize: "16px" }} />
    </Card>
  );
};
